import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/choosePin";

export default function ChoosePin({
  goBack,
  goToPin,
}: PropsView) {
  return (
    <div className="h-full relative">
      <Header
        title="Validação"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="h-12">
            <h2 className="mt-6 text-black text-xl">Validar cadastro</h2>
            <h3 className="text-black text-sm mt-2">Escolha como quer receber o código para validar seu acesso.</h3>
            <div className="mt-6 flex flex-col justify-center items-center">
              <button onClick={() => goToPin("phone")} className="w-full flex justify-between items-center text-start">
                <div className="flex items-center">
                  <img 
                    src={"/icon-sms.png"}
                    width={24}
                    height={24}
                    alt="sms icon"
                  />
                  <div className="ml-3">
                    <p className="text-base text-black">SMS</p>
                    <p className="text-xs text-black">Receber código no celular cadastrado</p>
                  </div>
                </div>
                <img 
                  src={"/arrow-right.png"}
                  width={24}
                  height={24}
                  alt="escolher pix"
                />
              </button>
              <div className="w-full h-px bg-slate-300 mt-4 mb-4" />
              <button onClick={() => goToPin("email")} className="w-full flex justify-between items-center text-start">
                <div className="flex items-center">
                  <img 
                    src={"/icon-email.png"}
                    width={24}
                    height={24}
                    alt="email icon"
                  />
                  <div className="ml-3">
                    <p className="text-base text-black">E-mail</p>
                    <p className="text-xs text-black">Receber código no e-mail cadastrado</p>
                  </div>
                </div>
                <img 
                  src={"/arrow-right.png"}
                  width={24}
                  height={24}
                  alt="escolher pix"
                />
              </button>
            </div>
          </div>
        </article>
      </main>
    </div>
  );
}
